import { generateClient, GraphQLResult } from "aws-amplify/data";

export const makeCall = async <T>(
  name: Readonly<string>,
  query: Readonly<string>,
  variables?: any
) => {
  const client = generateClient({
    authMode: "identityPool",
  });
  const result = (await client.graphql({
    query,
    variables,
  })) as GraphQLResult;

  console.log(`GraphQL response for ${name}`, { query, variables, result });

  if (result?.data) {
    return (result.data as any)[name] as T;
  }

  console.log(`Unknown response from graph api ${name}`, {
    query,
    variables,
    result,
  });
  return undefined;
};
